import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import WithSideNaviWrapper from "../router/with-side-navi-wrapper";
import { roleTabViews } from "./tabs/view/info-view";

export const MANAGE_ROLE_ROUTES = [
  {
    index: true,
    lazy: () => import("./role-list"),
  },
  {
    path: "new",
    lazy: () => import("../company-roles/tabs/create"),
  },
  {
    path: ":roleId/*",
    element: <WithSideNaviWrapper component={Outlet} navInfo={roleTabViews} />,
    children: [
      {
        index: true,
        element: <Navigate to="info" replace />,
      },
      {
        path: "info",
        lazy: () => import("./tabs/view/info-view"),
      },
      {
        path: "permissions",
        lazy: () => import("./tabs/view/permissions-view"),
      },
    ],
  },
  {
    path: ":roleId/edit/*",
    element: <WithSideNaviWrapper component={Outlet} />,
    children: [
      {
        path: "info",
        lazy: () => import("./tabs/edit/role-info-edit"),
      },
      {
        path: "permissions",
        lazy: () => import("./tabs/edit/role-permissions-edit"),
      },
    ],
  },
];
